import {
  Button,
  FixedFooter,
  InputSearch,
  ZenInput,
  ZenSelect,
} from "@/components";
import { InfoIcon, TrashIcon, XIcon } from "@/assets/Icons";
import {
  ButtonContainerStyled,
  DivFlex,
  EditarCamposContainer,
  FormContainer,
  InfoContainer,
  InfoIconWrapper,
  InputContainer,
  LinkedFieldRow,
  TitleForm,
  TrashBtn,
} from "./style";
import { useEditarCampos } from "./useEditarCampos";

export function EditarCampos() {
  const {
    availableFields,
    linkedFields,
    addField,
    removeField,
    setVtexKey,
    getAvailableVtexOptions,
    handleSave,
    showInfo,
    setShowInfo,
  } = useEditarCampos();

  return (
    <EditarCamposContainer>
      <DivFlex>
        <FormContainer size="60%">
          <h1>Vincular Campos</h1>
          <InputContainer>
            {linkedFields.length > 0 && (
              <TitleForm>
                <label>Campos Zendesk</label>
                <label>Campos VTEX</label>
              </TitleForm>
            )}
            {linkedFields.map((lf) => (
              <LinkedFieldRow key={lf.zendeskField.id}>
                <ZenInput
                  value={lf.zendeskField.title}
                  onChange={() => {}}
                  disabled
                />
                <TrashBtn
                  type="button"
                  onClick={() => removeField(lf.zendeskField.id)}
                >
                  <TrashIcon />
                </TrashBtn>
                <ZenSelect
                  placeholder="Selecione um campo VTEX"
                  options={getAvailableVtexOptions()}
                  value={lf.vtexKey}
                  onChange={(vtexKey) =>
                    setVtexKey(lf.zendeskField.id, vtexKey)
                  }
                />
              </LinkedFieldRow>
            ))}
          </InputContainer>
        </FormContainer>

        <FormContainer border size="40%">
          <InputSearch
            expanded
            label="Pesquisar"
            placeholder="Pesquisar campo Zendesk..."
            options={availableFields.map((f) => ({
              id: f.id,
              label: `+ ${f.title}`,
            }))}
            //   isLoading={isLoading}
            onSelect={(option) => {
              const field = availableFields.find((f) => f.id === option.id);
              if (field) addField(field);
            }}
          />
        </FormContainer>
      </DivFlex>

      {showInfo && (
        <InfoContainer>
          <InfoIconWrapper>
            <InfoIcon />
          </InfoIconWrapper>
          <button onClick={(p) => setShowInfo(!p)}>
            <XIcon />
          </button>
          <p>
            <strong>Informação</strong>
          </p>
          <p>
            Relacione quais campos devem ser preenchidos na Zendesk com o
            conteúdo que está no VTEX (essa informação só é preenchida no campo
            com o botão 'Salvar' dentro do app)
          </p>
        </InfoContainer>
      )}

      <FixedFooter>
        <ButtonContainerStyled>
          <Button isPrimary onClick={handleSave}>
            Salvar
          </Button>
        </ButtonContainerStyled>
      </FixedFooter>
    </EditarCamposContainer>
  );
}
